import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { trendingSearches } from '../../../mocks/homepage';

export default function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/products?search=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  const handleTrendingClick = (term: string) => {
    navigate(`/products?search=${encodeURIComponent(term)}`);
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-carbon-950">
      {/* Grid pattern overlay */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
        backgroundSize: '60px 60px'
      }}></div>

      {/* Gradient orbs */}
      <div className="absolute top-20 right-20 w-[500px] h-[500px] bg-neon/5 blur-[120px]"></div>
      <div className="absolute bottom-20 left-20 w-[400px] h-[400px] bg-neon/3 blur-[100px]"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full text-center py-32">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 border border-white/10 mb-8">
          <span className="w-1.5 h-1.5 bg-neon animate-pulse"></span>
          <span className="text-white/70 text-xs font-medium tracking-wide uppercase">500+ curated tools reviewed &amp; compared</span>
        </div>

        <h1 className="text-6xl lg:text-8xl font-bold text-white leading-[0.95] mb-8 max-w-5xl mx-auto tracking-tight">
          Find the Best
          <span className="block mt-2 text-neon">
            Tech Tools
          </span>
        </h1>

        <p className="text-base text-white/40 max-w-2xl mx-auto mb-14 leading-relaxed">
          Honest reviews, real comparisons, and exclusive deals on the top software and tools. Stop guessing — start growing with the right products.
        </p>

        <form onSubmit={handleSearch} className="max-w-2xl mx-auto mb-10">
          <div className="flex items-center bg-white/10 border border-white/20 overflow-hidden hover:border-white/30 transition-colors">
            <div className="w-5 h-5 flex items-center justify-center ml-5">
              <i className="ri-search-line text-white/50 text-lg"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search for tools, software, or categories..."
              className="flex-1 px-4 py-4 text-sm text-white placeholder-white/50 focus:outline-none bg-transparent"
            />
            <button
              type="submit"
              className="px-8 py-4 bg-neon text-black text-sm font-bold hover:bg-neon/90 transition-colors whitespace-nowrap cursor-pointer"
            >
              Search
            </button>
          </div>
        </form>

        <div className="flex flex-wrap items-center justify-center gap-2">
          <span className="text-white/20 text-xs font-medium mr-1 uppercase tracking-wider">Trending:</span>
          {trendingSearches.map((term) => (
            <button
              key={term}
              onClick={() => handleTrendingClick(term)}
              className="px-3 py-1.5 bg-white/5 text-white/50 text-xs hover:bg-white/10 hover:text-white/80 transition-all cursor-pointer border border-white/5 whitespace-nowrap"
            >
              {term}
            </button>
          ))}
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
          <span className="text-white/20 text-[10px] uppercase tracking-widest">Scroll</span>
          <div className="w-px h-8 bg-gradient-to-b from-white/20 to-transparent"></div>
        </div>
      </div>
    </section>
  );
}
